// extracted by mini-css-extract-plugin
module.exports = {"item":"PaymentPage_item__1WiF_"};